import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { NgxCurrencyDirective } from 'ngx-currency';
import { UtilService } from '../../../../../shared/services/util.service';

@Component({
  selector: 'app-servico-tomado-impostos-retidos',
  standalone: true,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, NgxCurrencyDirective],
  templateUrl: './servico-tomado-impostos-retidos.component.html',
})
export class ServicoTomadoImpostosRetidosComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() dynamicCurrencyMask: any;
  @Input() percentageMask: any;

  /**
   * Recalcula o valor retido (base × alíquota / 100) de um grupo (ex.: 'ir', 'inss', 'iss').
   *
   * Arredondamento ABNT (NBR 5891), não Math.round: em valor fiscal o 0,5 exato vai para o par,
   * e não sempre para cima — usar Math.round produz centavo divergente do resto do sistema.
   */
  public recalcular(prefixo: 'ir' | 'inss' | 'iss'): void {
    const base = Number(this.form.get(`${prefixo}Base`)?.value) || 0;
    const aliquota = Number(this.form.get(`${prefixo}Aliquota`)?.value) || 0;
    const valor = UtilService.arredondarAbnt(base * aliquota / 100, 2);
    this.form.get(`${prefixo}Valor`)?.setValue(valor || null, { emitEvent: false });
  }

  /**
   * PIS/COFINS/CSLL retidos não têm campo de base próprio no AC — usa o Valor do Serviço
   * (seção Serviços, mesmo form) como base de cálculo da retenção.
   */
  public recalcularSemBase(prefixo: 'pisRetido' | 'cofinsRetido' | 'csllRetido'): void {
    const base = Number(this.form.get('valorServico')?.value) || 0;
    const aliquota = Number(this.form.get(`${prefixo}Aliquota`)?.value) || 0;
    const valor = UtilService.arredondarAbnt(base * aliquota / 100, 2);
    this.form.get(`${prefixo}Valor`)?.setValue(valor || null, { emitEvent: false });
  }
}
